import { useReactiveVar } from '@apollo/client'
import { IonPage, IonFooter, IonToolbar, IonLoading, IonTitle, IonButton } from '@ionic/react'
import IonContent from '../../components/IonContent'

import React, { useEffect, useState } from 'react'
import { Box, Button, Flex, Image, Text } from 'rebass/styled-components'
import styled from 'styled-components'
import { useLocation, useHistory } from 'react-router-dom'

import OverflowText from '../../components/OverflowText'
import Price from '../../components/Price'
import Header from '../../components/Header'
import { checkoutVar, setCheckout } from '../../graphql/client'
import { useCheckoutLineItemsUpdate } from '../../graphql/mutations'
import { fmtImageSize, storage } from '../../utils/index'

const StepBtn = styled(Flex)`
    width: 30px;
    height: 30px;
    align-items: center;
    justify-content: center;
    border: 1px solid #eee;
    cursor: pointer;
`

export const ProductListItem = ({ item }) => {
    const { node } = item

    const [mutate, loading] = useCheckoutLineItemsUpdate()
    const handleAdd = (node) => () => {
        handleUpdate(node.id, node.quantity + 1)
    }

    const handleUpdate = (id, quantity) => {
        const checkout = storage.getItem('checkout')
        mutate({
            variables: {
                lineItems: [
                    {
                        id,
                        quantity,
                    },
                ],
                checkoutId: checkout.id,
            },
        })
    }

    const handleReduce = (node) => () => {
        handleUpdate(node.id, node.quantity - 1)
    }

    return (
        <Flex mb="16px">
            <IonLoading isOpen={loading}></IonLoading>
            <Box flex="none">
                <Image src={fmtImageSize(node?.variant?.image.src)} width="80px" height="80px" />
            </Box>
            <Flex flexDirection="column" justifyContent="space-between" pl="10px" flex="1">
                <OverflowText>{node.title}</OverflowText>
                <Flex justifyContent="space-between" alignItems="flex-end">
                    <Text color="secondary">${node.variant?.price}</Text>
                    <Flex alignItems="center">
                        <StepBtn onClick={handleReduce(node)}>-</StepBtn>
                        <Flex
                            width="50px"
                            height="30px"
                            alignItems="center"
                            justifyContent="center"
                            css={{
                                border: '1px solid #eee',
                                textAlign: 'center',
                            }}
                        >
                            {node.quantity}
                        </Flex>
                        <StepBtn onClick={handleAdd(node)}>+</StepBtn>
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    )
}

export default () => {
    const checkout = useReactiveVar(checkoutVar)
    const { lineItems, totalPrice } = checkout

    console.log(history)

    const handleCheckout = () => {
        setCheckout([])
        window.location.assign(checkout.webUrl)
        setShow(false)
    }

    const len = lineItems?.edges?.length

    const location = useLocation()
    const [show, setShow] = useState(true)

    useEffect(() => {
        if (location.pathname === '/cart') {
            setShow(true)
        }
    }, [location])

    return (
        <IonPage>
            {show && <Header title="Cart"></Header>}

            <IonContent fullscreen>
                <Box p="10px">
                    {len < 1 && <Text>购物车是空的</Text>}
                    {lineItems?.edges.map((item, index) => (
                        <ProductListItem item={item} key={index}></ProductListItem>
                    ))}
                </Box>
            </IonContent>
            {len > 0 && (
                <IonFooter>
                    <IonToolbar>
                        <IonTitle>
                            Total: <Price>{totalPrice}</Price>
                        </IonTitle>
                        <IonButton slot="end" onClick={handleCheckout}>
                            Checkout
                        </IonButton>
                    </IonToolbar>
                </IonFooter>
            )}
        </IonPage>
    )
}
